export const MRO_CONFIRM_BUTTON_TEXT = "Confirm";

export const SELF_DELIVERY_METHOD_LABEL = "Delivered directly by restaurant";

export const DEFAULT_RX_IMAGE = "portal/m/mro-rx-card-fallback.png";

export const RX_NAME_IMAGE_SIZE = {
    height: "24px",
    width: "24px",
};

export const HALF_CARD_RX_IMAGE_SIZE = {
    height: "20px",
    width: "20px",
};

export const MRO_CART_DELIVERY_SPEED_OPTION_ID_PREFIX = "mro-cart-delivery-speed-option";
